import { Component, OnInit } from '@angular/core';
import * as JSZip from 'jszip';
import { FilesProvider, FileRaw, ImageReadyService } from './providers/';
import { FileClass } from './file.class';
import { Observable } from 'rxjs';
import { saveAs } from 'file-saver';

interface ZipStorage {
  expires: number;
  files: string[];
  ticket: number;
}

@Component({
  selector: 'file-download-zip',
  template: `
  <div class="wp-overlay">
    <div class="wp-modal wp-center">
      <h4>Download Zip</h4>
      <div style="display:block; width:100%; padding: 1rem;">
        <p>
          Status: {{status}}
        </p>
        <div class="progress" *ngIf="progress > 0">
          <div class="progress-bar" [style.width]="progress + '%'"></div>
        </div>

      </div>
    </div>
  </div>
  `,
  styles: [
    `
      .progress {
        background-color: transparent;
        font-size: inherit;
        height: 2em;
        max-height: 0.583333rem;
        min-height: 0.166667rem;
        display: block;
        width: 100%;
        border-radius: 0px;
        margin: 0px;
        overflow: hidden;
        -webkit-appearance: none;
        background-color: rgb(238, 238, 238);
        color: rgb(0, 124, 187);
        border-width: initial;
        border-style: none;
        border-color: initial;
        border-image: initial;
      }
      .progress-bar {
        display: block;
        background-color: rgb(0, 124, 187);
        height: 100%;
      }
    `
  ]
})
export class FileZipDownload implements OnInit {
  zip: any;
  ticket: number;
  storage: any;
  status: string = ''
  files: FileClass[] = [];
  progress: number = 0;
  constructor(public fp: FilesProvider, private irs: ImageReadyService) {
    this.zip = new JSZip();
    if (typeof(localStorage) === 'undefined') {
      console.error('Your browser does not support downloading');
    }
    this.storage = localStorage;
    this.irs.progress.subscribe((progress: any) => {
      let count = progress.length;
      let total = 100 * count;
      let subtotal = 0;
      progress.forEach((item: any) => subtotal += +item.progress);
      let done = subtotal / total;
      this.progress = done * 100;
    });
  }

  ngOnInit() {
    let data = this.storage.getItem('wpZipFiles');
    if (!data) {
      console.error('No Data');
      return false;
    }
    let json: ZipStorage = JSON.parse(data);
    let now = new Date();
    if (json.expires < now.getTime()) {
      this.storage.removeItem('wpZipFiles');
      console.error('Data expired');
      return false;
    }
    this.ticket = json.ticket;
    this.status = 'Getting file data';
    this.getFilesData(json.files);

  }

  private getFilesData(files: string[]) {
    let tasks = [];
    files.forEach((item: string) => tasks.push(this.fp.getFileData(item)));
    if (tasks.length) {
      Observable.forkJoin(tasks).subscribe((res) => {
        res.forEach((fileRes: any) => {
          let file = fileRes.file;
          let locFile = file.file2 ? file.file2 : file.file;
          let nameFound = this.files.filter((f: FileClass) => {
            let test = f.name.replace(/\(\d\)/i, '');
            return file.name === f.name || file.name === test;
          });
          let name = file.name;
          if (nameFound.length) {
            let temp = file.name.split(".");
            let extension = temp.pop();
            name = temp.join('.') + "(" + nameFound.length + ")." + extension;
          }
          this.files.push(new FileClass(file.encryptedID, name, locFile, file.mime));
        });
        this.status = 'Downloading Files';
        this.createZip();
      });
    }
  }

  private createZip() {
    let tasks = [];
    this.files.forEach((file:any) => tasks.push(this.fp.getFile(file.id, file.mime, file.name)));
    Observable.forkJoin(tasks).subscribe((res) => {
      //Add files to zip
      for (let i = 0; i < res.length; i++) {
        this.zip.file(this.files[i].name, res[i]);
      }
      this.status = 'Creating Zip';
      this.zip.generateAsync({type:"blob"}).then((blob) => {
        this.status = 'Zip Created';
        saveAs(blob, this.ticket + '.zip');
        this.storage.removeItem('wpZipFiles');
        setTimeout(() => window.close(), 500);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/file.zip.download.component.ts